import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import styles from './index.module.less';

const COOKIE_NOTICE_KEY = 'codeflicker_cookie_notice_dismissed';

interface CookieNoticeProps {
  onlyShowOnHome?: boolean;
}

const CookieNotice: React.FC<CookieNoticeProps> = ({ onlyShowOnHome = true }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    // 检查是否已经显示过
    const isDismissed = localStorage.getItem(COOKIE_NOTICE_KEY);

    // 如果设置了仅在首页显示，检查当前路径
    if (onlyShowOnHome && window.location.pathname !== '/') {
      return;
    }

    if (!isDismissed) {
      // 延迟3秒后显示
      const showTimer = setTimeout(() => {
        setIsVisible(true);
        // 稍微延迟一下再触发动画，确保DOM已渲染
        setTimeout(() => {
          setIsAnimated(true);
        }, 50);
      }, 2000);

      return () => clearTimeout(showTimer);
    }
  }, [onlyShowOnHome]);

  const handleDismiss = () => {
    setIsAnimated(false);
    // 等待动画完成后再隐藏
    setTimeout(() => {
      localStorage.setItem(COOKIE_NOTICE_KEY, 'true');
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`${styles.cookieNotice} ${isAnimated ? styles.animated : ''}`}>
      <div className={styles.content}>
        <div className={styles.textSection}>
          <h3 className={styles.title}>{t('cookieNotice.title')}</h3>
          <p className={styles.description}>
            <span className={styles.descriptionText}>
              {t('cookieNotice.description')}{' '}
              <Link to="/policies/cookie-policy" className={styles.policyLink}>
                {t('cookieNotice.learnMore')}
              </Link>
            </span>
          </p>
        </div>
        <button className={styles.gotItButton} onClick={handleDismiss} type="button">
          {t('cookieNotice.gotIt')}
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;